import {
  BooleanField,
  DateField,
  DeleteButton,
  EditButton,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from 'react-admin'
import Permission from '../../components/Permission'
import { EmailVerificationWarning, ResendEmailButton } from '../../components/EmailVerificationAlerts'
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton'
import { PERMISSIONS } from '../../constants'

const UserShowActions = () => (
  <TopToolbar>
    <Permission permission={PERMISSIONS.UPDATE_USER}>
      <EditButton />
    </Permission>
    <ResendEmailButton />
    <Permission permission={PERMISSIONS.ADMIN}>
      <MarkVerifiedButton />
    </Permission>
    <Permission permission={PERMISSIONS.UPDATE_USER}>
      <DeleteButton mutationMode="pessimistic" redirect="/employees" confirmTitle="Excluir usuário" />
    </Permission>
  </TopToolbar>
)

const UserShow = props => (
  <Show {...props} title="Usuário da rede" actions={<UserShowActions />}>
    <SimpleShowLayout>
      <EmailVerificationWarning />
      <TextField source="name" label="Nome" />
      <TextField source="login" label="Login (email)" />
      <ReferenceField source="chainId" reference="chains" label="Rede" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField source="profileId" reference="profiles" label="Perfil" link={false}>
        <TextField source="name" />
      </ReferenceField>
      <BooleanField source="emailVerified" label="Email verificado" />
      <DateField source="createdAt" label="Criado em" showTime locales="pt-BR" />
    </SimpleShowLayout>
  </Show>
)

export default UserShow
